<template>
  <el-dialog
    title="分配标签"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="130px">
      <el-form-item
        label="机构："
        prop="seaportId">
        <seaport-select v-model="info.sgsId" />
      </el-form-item>
      <el-form-item
        label="标签数量："
        prop="tagCount">
        <el-input-number
          v-model="info.tagCount"
          :max="config.maxCount"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="开始标签序号："
        prop="beginTagNo">
        <el-input-number
          v-model="info.beginTagNo"
          :controls="false"
          :max="config.max"
          :min="config.min"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="结束标签序号：">
        <span>{{ endTagNo }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        :disabled="!endTagNo"
        @click="handleSubmit"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import SeaportSelect from './seaportSelect.vue'
export default {
  name: 'PubModal',
  components: { SeaportSelect },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      config: {
        max: null,
        min: null,
        maxCount: null
      },
      info: {
        tagCount: undefined,
        beginTagNo: undefined,
        sgsId: null
      },
      rules: {
        sgsId: [
          { required: true, message: '请选择机构', trigger: 'change' }
        ],
        tagCount: [
          { required: true, message: '请输入标签数量', trigger: 'blur' }
        ],
        beginTagNo: [
          { required: true, message: '请输入开始标签序号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    endTagNo() {
      const { tagCount, beginTagNo } = this.info
      const max = this.config.max
      return tagCount && beginTagNo
        ? Math.min(+tagCount + +beginTagNo - 1, max)
        : ''
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        const { tagCount, beginTagNo } = this.info
        const endTagNo = this.endTagNo
        if (tagCount !== endTagNo - beginTagNo + 1) {
          this.$message.error('请输入正确的数据')
          return
        }
        if (valid) {
          this.loading = true
          this.$store.dispatch(`account/assigntagsegment`, {
            payload: {
              ...this.info,
              endTagNo: this.endTagNo,
              tagSegId: this.config.tagSegId
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(options = {}) {
      this.config = {
        ...this.config,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
